import React from "react";
import { get, isEmpty } from "lodash";
import { TableRow, TableCell } from "@material-ui/core";
import { LEGACY_AUDIO_SECTION } from "../../../constants/ContentFinder";
import { displayData } from "../../../utils/ContentFinderUtils";
import DrawerTable from "./DrawerTable";

const LegacyAudioSection = ({ legacyAudioTracks, versionCreatedAt }) => {
  const tracks = [...legacyAudioTracks].sort(
    (a, b) => (a.trackNum || 0) - (b.trackNum || 0)
  );

  return (
    <DrawerTable
      title={LEGACY_AUDIO_SECTION.title}
      headers={LEGACY_AUDIO_SECTION.headers}
      isEmpty={isEmpty(tracks)}
      emptyMessage={LEGACY_AUDIO_SECTION.emptyMessage}
    >
      {tracks.map((track, i) => (
        <TableRow key={i} className="tableRow content-finder-body-row">
          <TableCell className="content-finder-table-cell">
            {displayData(get(track, "audioType"))}
          </TableCell>
          <TableCell className="content-finder-table-cell">
            {displayData(get(track, "language"))}
          </TableCell>
          <TableCell className="content-finder-table-cell">
            {displayData(get(track, "version"), { displayFallback: "0" })}
          </TableCell>
          <TableCell className="content-finder-table-cell">
            {displayData(get(track, "dateAdded") || versionCreatedAt, {
              dateFormat: "YYYY-MM-DD",
            })}
          </TableCell>
        </TableRow>
      ))}
    </DrawerTable>
  );
};

export default LegacyAudioSection;
